import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ImpactAssessmentStore {
  private nodeDataSubject = new BehaviorSubject<any>(undefined);
  private nodeData$ = this.nodeDataSubject.asObservable().pipe(distinctUntilChanged());

  private treeDataSubject = new BehaviorSubject<any>(undefined);
  private treeData$ = this.treeDataSubject.asObservable().pipe(distinctUntilChanged());

  get nodeData() {
    return this.nodeDataSubject.value;
  }

  get treeData() {
    return this.treeDataSubject.value;
  }

  select<T>(name: string): Observable<T> {
    return this[`${name}$`];
  }

  set(name: string, stateValue: any) {
    this[`${name}Subject`].next(stateValue);
  }
}
